import React from "react";
import "./App.css";
import Navbar from "./components/estaticos/navbar/Navbar";
import Footer from "./components/estaticos/footer/Footer";
import Home from "./paginas/home/Home";
import Login from "./paginas/login/Login";
import SobreOProjeto from "./paginas/SobreOProjeto/SobreOProjeto";
import CadastroUsuario from "./paginas/cadastroUsuario/CadastroUsuario";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ListaTema from "./components/temas/listatema/ListaTema";
import ListaPostagem from "./components/postagens/listaPostagem/ListaPostagem";
import CadastroPost from "./components/postagens/cadastroPost/CadastroPost";
import CadastroTema from "./components/temas/cadastroTema/CadastroTema";
import DeletarPostagem from './components/postagens/deletarPostagem/DeletarPostagem';
import DeletarTema from "./components/temas/deletarTema/DeletarTema";
import { Provider } from "react-redux";
import store from "./store/store";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'
import Perfil from './components/perfil/Perfil';
import PutUsuario from "./components/putUsuario/PutUsuario";
import ListaPorTema from "./components/temas/listaPorTema/ListaPorTema";
import PerfilUsuarios from "./components/perfil/perfilusuarios/PerfilUsuarios";
import AtualizarTema from "./components/temas/atualizarTema/AtualizarTema";


function App() {
  return (
    <Provider store={store}>
    <ToastContainer />
    <Router>
      <Navbar />
      <div style={{ minHeight: "100vh" }}>
        <Routes>
          <Route path="/" element={<Login />} />
          
          <Route path="/perfil" element={<Perfil />} />

          <Route path="/atualizarcadastro" element={<PutUsuario />} />


          <Route path="/login" element={<Login />} />

          <Route path="/home" element={<Home />} />

          <Route path="/cadastrar" element={<CadastroUsuario />} />
          <Route path="/sobreoprojeto" element={<SobreOProjeto />} />


          <Route path="/temas" element={<ListaTema />} />

          <Route path="/postagens" element={<ListaPostagem />} />

          <Route path="/formularioPostagem" element={<CadastroPost />} />

          <Route path="/AtualizarPostagem/:id" element={<CadastroPost />} />

          <Route path="/formularioTema" element={<CadastroTema />} />

          <Route path="/formularioTema/:id" element={<AtualizarTema />} />

          <Route path="/deletarPostagem/:id" element={<DeletarPostagem />} />

          <Route path="/deletarTema/:id" element={<DeletarTema />} />

          <Route path="/listaPorTema/:id" element={<ListaPorTema />} />

          <Route path="/perfilUsuarios/:id" element={<PerfilUsuarios />} />

        </Routes>
      </div>
      <Footer />
    </Router>
    </Provider>
  );
}

export default App;
